import { computed, Directive, input } from '@angular/core';

export const UiFieldActionTone = { Default: 'default', Danger: 'danger' } as const;
export type UiFieldActionTone = (typeof UiFieldActionTone)[keyof typeof UiFieldActionTone];

/**
 * A button inside a field's border (clear, toggle, open-panel): a square as tall as the field,
 * flush with its right edge — the shape `fr8bot-ui-autocomplete-field` gave its own buttons. The
 * host field drops its right padding so the square reaches the border.
 * The width is explicit (`--field-action-size`, 48px; 38px in small fields), not `aspect-square`:
 * iOS Safari leaves an aspect-ratio width out of the row's size and pushes the button outside it.
 */
@Directive({
  selector: 'button[uiFieldAction]',
  host: {
    type: 'button',
    class:
      'tw:flex tw:w-[var(--field-action-size,48px)] tw:h-full tw:shrink-0 tw:items-center tw:justify-center tw:border-0 tw:bg-transparent tw:p-0 tw:text-inherit tw:cursor-pointer tw:transition-colors tw:duration-200 tw:enabled:hover:bg-gray-5 tw:disabled:cursor-not-allowed',
    '[class]': 'toneClass()',
  },
})
export class UiFieldActionDirective {
  // A bare `uiFieldAction` attribute binds '' — that is the default tone.
  readonly tone = input<UiFieldActionTone | ''>('default', { alias: 'uiFieldAction' });

  protected readonly toneClass = computed(() =>
    this.tone() === UiFieldActionTone.Danger ? 'tw:enabled:hover:text-red' : '',
  );
}
